import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";

import ServicesLanding from "../views/ServicesLanding";
import ServiceDetailPage from "../views/ServiceDetailPage";

import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner4.jpg";
import banner3 from "../assets/packaging.jpg";
import banner4 from "../assets/banner4.jpg";
import chemicals from "../assets/banner2.jpg";
import zinc from "../assets/seed.jpg";
import maize from "../assets/ppe.jpg";


export default function Services() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  const serviceMap = {
    seed: {
      type: "Service",
      title: "Seed Production and Multiplication",
      tagline: "Reliable seed systems built on quality, scale, and farmer success.",
      description:
        "We produce certified seeds for maize, beans, and sunflower through our own farms and contracted out-grower networks in Mbeya. Our model ensures consistent quality, traceability, and availability for farmers and markets.",
      image: banner1,
      offeringsIntro: "Our seed production program delivers dependable supply and strong field performance.",
      offerings: [
        "Certified seed production and multiplication",
        "Contracted and out-grower farmer support",
        "Quality assurance and field inspections",
        "Market-ready packaging and distribution",
      ],
      highlights: [
        "Focused on climate-resilient varieties",
        "Strong local production capacity",
        "Reliable availability during planting seasons",
      ],
    },
    processing: {
      type: "Service",
      title: "Processing and Packaging",
      tagline: "Transforming raw seeds into high-value, high-performance products.",
      description:
        "We enhance shelf life and germination through efficient processing, grading, treatment, and packaging. This improves product integrity and ensures farmers receive seed that performs in real conditions.",
      image: banner3,
      offeringsIntro: "We maintain strict standards across the processing and packaging chain.",
      offerings: [
        "Seed cleaning, grading, and treatment",
        "Moisture control and quality testing",
        "Protective packaging for long shelf life",
        "Efficient distribution-ready preparation",
      ],
      highlights: [
        "Improved germination rates",
        "Uniform quality at scale",
        "Packaging that protects and informs",
      ],
    },
    agrochemical: {
      type: "Service",
      title: "Agrochemical, Fertilizers and Seed Distribution",
      tagline: "Trusted inputs delivered consistently to farming communities.",
      description:
        "We source agrochemicals from partners such as Parijat and Agroallied, and fertilizers from bulk suppliers like ETG. Our distribution network serves the Southern Highlands and Lake Zone.",
      image: chemicals,
      offeringsIntro: "We distribute trusted inputs that strengthen productivity and resilience.",
      offerings: [
        "Agrochemical sourcing from reputable manufacturers",
        "Fertilizer supply from verified bulk partners",
        "Last-mile distribution to farmer networks",
        "Technical guidance on safe application",
      ],
      highlights: [
        "Reliable supply chain management",
        "Partnered with trusted suppliers",
        "Coverage across key agricultural regions",
      ],
    },
    poultry: {
      type: "Service",
      title: "Supply of Day-Old Chicks and Poultry Feed",
      tagline: "Improving poultry productivity with trusted inputs.",
      description:
        "We are a leading agent for day-old chick and poultry feed suppliers such as Irvines, Falcon, Silverlands, Xiwang, Backbone, and Sharfa Ltd. We support thousands of farmers annually.",
      image: banner2,
      offeringsIntro: "Our poultry inputs are chosen for consistency and performance.",
      offerings: [
        "Day-old chick supply from trusted hatcheries",
        "Poultry feed distribution for smallholders",
        "Technical support for flock performance",
        "Reliable logistics and delivery schedules",
      ],
      highlights: [
        "Strong supplier partnerships",
        "High farmer adoption and satisfaction",
        "Improved productivity and profitability",
      ],
    },
    agroseeds: {
      type: "Product",
      title: "Agrochemicals",
      tagline: "Quality seeds and crop protection for reliable yields.",
      description:
        "Our agroseeds and agrochemicals are selected for performance in Tanzanian conditions. We supply inputs that support healthy crops, improved yields, and resilient production systems.",
      image: banner1,
      offeringsIntro: "We provide the essentials that growers need for strong harvests.",
      offerings: [
        "Certified seed varieties for key crops",
        "Crop protection inputs for major challenges",
        "Guidance on best application practices",
        "Consistent availability across seasons",
      ],
      highlights: [
        "Quality tested for field performance",
        "Aligned with local climate needs",
        "Supported by agronomic guidance",
      ],
    },
    high_iron_zinc_beans: {
      type: "Product",
      title: "High Iron and Zinc Beans",
      tagline: "Nutritious beans that improve diets and incomes.",
      description:
        "Our bio-fortified beans are rich in iron and zinc, supporting healthier communities while providing strong yields for farmers.",
      image: zinc,
      offeringsIntro: "These beans deliver nutrition and performance in one crop.",
      offerings: [
        "Bio-fortified varieties for improved nutrition",
        "Strong yield potential and adaptability",
        "Support for local and export markets",
        "Seed availability during key seasons",
      ],
      highlights: [
        "Enhanced micronutrient content",
        "Farmer-friendly cultivation",
        "Growing demand in nutrition programs",
      ],
    },
    stuka_m1: {
      type: "Product",
      title: "STUKA M1",
      tagline: "Premium, disease-resistant seed with excellent yield.",
      description:
        "STUKA M1 is built for resilience and productivity. It performs well under varied conditions, delivering reliable harvests for farmers and commercial producers.",
      image: maize,
      offeringsIntro: "A robust option for growers seeking dependable performance.",
      offerings: [
        "Disease-resistant seed profile",
        "Strong germination and field vigor",
        "Suitable for diverse agro-ecological zones",
        "Available in certified packaging",
      ],
      highlights: [
        "High yield potential",
        "Consistent field performance",
        "Trusted by commercial growers",
      ],
    },
  };

  function getView() {
    const { navSubItem, navExtraItem, navMoreItem } = appContext;

    /* SERVICES LANDING */
    if (!navSubItem && !navExtraItem && !navMoreItem) {
      return <ServicesLanding />;
    }

    /* BLOCK UNEXPECTED DEPTH */
    if (navExtraItem || navMoreItem) {
      return null;
    }

    /* SERVICE ROUTING */
    if (serviceMap[navSubItem]) {
      return <ServiceDetailPage service={serviceMap[navSubItem]} />;
    }

    return null;
  }

  useEffect(() => {
    setView(getView());
  }, [
    appContext.navSubItem,
    appContext.navExtraItem,
    appContext.navMoreItem
  ]);

  return view;
}
